
import './add.css'
import React, { useEffect, useState } from 'react'
import { useContext } from 'react';
import { AppContext } from '../../App';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddUser = () => {
    const {route ,setLoader ,imgRoute}=useContext(AppContext)
    const [product,setProduct]=useState([])
    const [show,setShow]=useState(false)
    const [name ,setName]=useState("")
    const [nickName ,setNickName]=useState("")
    const [fatherName ,setFatherName]=useState("")
    const [motherName ,setMotherName]=useState("")
    const [email ,setEmail]=useState("")
    const [gender,setGender]=useState("")
    const [phone,setPhone]=useState("")
    const [inheritor,setInheritor]=useState("")
    const [natNumber,setNatNumber]=useState("")
    const [qid,setQid]=useState("")
    const [amana,setAmana]=useState("")
    const [birthCountry,setBirthCountry]=useState("")
    const [birthCity,setBirthCity]=useState("")
    const [birthStreet,setBirthStreet]=useState("")
    const [birthDay,setBirthDay]=useState("")
    const [birthMonth,setBirthMonth]=useState("")
    const [birthYear,setBirthYear]=useState("")
    const [mDay,setMDay]=useState("")
    const [mMonth,setMMonth]=useState("")
    const [mYear,setMYear]=useState("")
    const [addressCountry,setAddressCountry]=useState("")
    const [addressCity,setAddressCity]=useState("")
    const [addressStreet,setAddressStreet]=useState("")
    const [shippingStreet,setShippingStreet]=useState("")
    const [shippingCountry,setShippingCountry]=useState("")
    const [shippingCity,setShippingCity]=useState("")
    const [idFron,setIdFront]=useState(null)
    const [idBack,setIdBack]=useState(null)
    const [health,setHealth]=useState(null)
    const[bocket,setBocket]=useState("")
    const [productId,setProductId]=useState("")  
    const history =useNavigate()

    const handleFront = (event) => {
        const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setIdFront(file);
    } else {
      setIdFront(null);
    }
    };

    const handleBack = (event) => {
        const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setIdBack(file);
    } else {
      setIdBack(null);
    }
    };
    const handleHealth = (event) => {
        const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setHealth(file);
    } else {
      setHealth(null);
    }
    };

    const clickProduct =(id)=>{
        setProductId(id)
        setShow(false)
    }


    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoader(true)
    
        const formData = new FormData();
        formData.append('name', name);
        formData.append('nickname', nickName);
        formData.append('father_name', fatherName);
        formData.append('mother_name', motherName);
        formData.append('gender',gender);
        formData.append('email', email);
        formData.append('phone', phone);
        formData.append('inheritor', inheritor);
        formData.append('national_number', natNumber);
        formData.append('qid', qid);
        formData.append('amana', amana);
        formData.append('birth_country', birthCountry);
        formData.append('birth_city', birthCity);
        formData.append('birth_street', birthStreet);
        formData.append('b_day', birthDay);
        formData.append('b_month', birthMonth);
        formData.append('b_year', birthYear);
        formData.append('m_day', mDay);
        formData.append('m_month', mMonth);
        formData.append('m_year', mYear);
        formData.append('bocket_password', bocket);
      
    
     
        try {
          const response = await fetch(`${route}/market/createUser`, {
            method: 'POST',
        
            headers:{
              "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
            },
            body: formData,
          })
          .then(res=>res.json());
          setLoader(false)
          console.log(response)
          if (response.status=="success") {
      console.log(response)
      toast.success("تمت الأضافة")
      history("/my-team")


          } 
          else  if(response.error === "Token expired"){
            toast.error("قم بتسجيل الخروج و ادخل مرة اخري")
          }
          else  if(response.error){
            toast.error(response.error)
          }
          else  if(response.status === "faild"){
            toast.error(response.msg)
          }
          else  if(response.errors){
            toast.error(response.errors.error)
          }
          else {
            console.log(response)
            toast.error("هناك خطأ")
          }
        } catch (error) {
       
        }
      };

    useEffect(()=>{
        fetch(`${route}/product`)
        .then(res=>res.json())
        .then(data=>{
          if(data.data){
            console.log(data.data)
            setProduct(data.data)
          }
        })
      },[])
  return (
  <div className="add">
    {show ?<div className="products">
        <div className="lay" onClick={()=>setShow(false)} ></div>
        <div className="in-prods">
            {product.map((pr,index)=>{
                return(
                    <div className="pr-card" onClick={()=>clickProduct(pr.id)} key={index}>
                        <div className="title">{pr.title}</div>
                        {pr.images.map((img,index)=>{
                            if(index === 0){

                                return(
                                    <img src={`${imgRoute}/${img.image}`} />
                                )
                            }
                        })}
                        <div className="desc">{pr.desc}</div>
                        <div className="price">{pr.price}</div>
                    </div>
                )
            })}
        </div>

    </div> : null}
    <div className="container">
        <h2>اٍضافة عضو جديد</h2>
        <form action=""  onSubmit={handleSubmit}>
            <label htmlFor="">
                <input onChange={(e)=>setName(e.target.value)} type="text" />
                الاسم
            </label>
            <label htmlFor="">
                <input onChange={(e)=>setNickName(e.target.value)} type="text" />
                النسبة
            </label>
            <label  htmlFor="">
                <input onChange={(e)=>setFatherName(e.target.value)} type="text" />
                اسم الاب
            </label>
            <label htmlFor="">
                <input onChange={(e)=>setMotherName(e.target.value)} type="text" />
                اسم الام
            </label>
            {/* <label htmlFor="">
                <input onChange={(e)=>setEmail(e.target.value)} type="text" />
                الايميل
            </label> */}
            <label htmlFor="">
                <input onChange={(e)=>setPhone(e.target.value)} type="text" />
                رقم الهاتف
            </label>
            <label htmlFor="">
               <select name="" id="" onChange={(e)=>setGender(e.target.value)}>
                <option value="">اختر</option>
                <option value="male">ذكر</option>
                <option value="female">أنثي</option>
               </select>
                الجنس
            </label>
            <label htmlFor="">
                <input onChange={(e)=>setInheritor(e.target.value)} type="text" />
                الوريث
            </label>
            <label htmlFor="">
                <input onChange={(e)=>setNatNumber(e.target.value)} type="text" />
                الرقم القومي
            </label>
            <label htmlFor="">
                <input onChange={(e)=>setQid(e.target.value)} type="text" />
                القيد
            </label>
            <label htmlFor="">
                <input onChange={(e)=>setAmana(e.target.value)} type="text" />
                الأمانة
            </label>
            <label htmlFor="">
                <input onChange={(e)=>setBirthCountry(e.target.value)} type="text" />
                بلد المنشأ
            </label>
            <label htmlFor="">
                <input onChange={(e)=>setBirthCity(e.target.value)} type="text" />
                مدينة المنشأ
            </label>
            <label htmlFor="">
                <input onChange={(e)=>setBirthStreet(e.target.value)} type="text" />
                شارع المنشأ
            </label>
            <div className="birth-day">
                تاريخ الميلاد
            <div className="inpts">
            <input onChange={(e)=>setBirthDay(e.target.value)} type="number" placeholder='اليوم' />
                <input onChange={(e)=>setBirthMonth(e.target.value)} type="number" placeholder='الشهر'  />
                <input onChange={(e)=>setBirthYear(e.target.value)} type="number" placeholder='السنة'  />
            </div>
            </div>
            <div className="birth-day">
                تاريخ المنح
            <div className="inpts">
            <input onChange={(e)=>setMDay(e.target.value)} type="number" placeholder='اليوم' />
                <input onChange={(e)=>setMMonth(e.target.value)} type="number" placeholder='الشهر'  />
                <input onChange={(e)=>setMYear(e.target.value)} type="number" placeholder='السنة'  />
            </div>
            </div>
            {/* <label htmlFor="">
                <input onChange={(e)=>setAddressCountry(e.target.value)}  type="text" />
                بلد الاقامة
            </label>
            <label htmlFor="">
                <input onChange={(e)=>setAddressCity(e.target.value)} type="text" />
                مدينة الاقامة
            </label>
         
            <label htmlFor="">
                <input onChange={(e)=>setAddressStreet(e.target.value)} type="text" />
شارع الاقامة            </label>
            <label htmlFor="">
                <input onChange={(e)=>setShippingCountry(e.target.value)} type="text" />
                بلد لشحن
            </label>
            <label htmlFor="">
                <input onChange={(e)=>setShippingCity(e.target.value)} type="text" />
                مدينة الشحن
            </label>
            <label htmlFor="">
                <input onChange={(e)=>setShippingStreet(e.target.value)} type="text" />
                شارع الشحن
            </label>
            <label htmlFor="">
                <input type="file" onChange={handleFront} />
               صورة الهوية الأمامية
            </label>
            {idFron ?<img src={URL.createObjectURL(idFron)} alt="بق" />: null}
     
            <label htmlFor="">
                <input type="file" onChange={handleBack} />
                صورة الهوية الخلفيه
            </label>
            {idBack ?<img src={URL.createObjectURL(idBack)} alt="بق" />: null}
            <label htmlFor="">
                <input type="file" onChange={handleHealth} />
               صورة الضمان الصحي 
            </label>
            {health ?<img src={URL.createObjectURL(health)} alt="بق" />: null} */}
            <label htmlFor="">
                <input onChange={(e)=>setBocket(e.target.value)}  />
كلمة سر الخزنة            </label>
            {/* <div className="choose" onClick={()=>setShow(true)}>اختر المنتج</div> */}
            

{product.map((pr, index) => {
  if (productId === pr.id) {
    return (
      <div key={index}>
        {pr.images.map((im, imgIndex) => {
          if (imgIndex === 0) {
            return (
              <img key={imgIndex} src={`${imgRoute}/${im.image}`} alt={`Product ${index} Image ${imgIndex}`} />
            );
          }
          return null; // or any other fallback
        })}
      </div>
    );
  }
  return null; // or any other fallback
})}


            <button>انشاء</button>
        </form>
    </div>
  </div>
  )
}

export default AddUser

